import Button from 'components/Button/Button';
import PubSwitcherLogo from 'components/PubSwitcherLogo/PubSwitcherLogo';

import './NavbarItems.scss';

interface IProps {
  isSelectingBeers: boolean;
  setShowPubSwitcher: React.Dispatch<React.SetStateAction<boolean>>;
}

const NavbarItems = ({setShowPubSwitcher, isSelectingBeers}: IProps) => {
  return (
    <div className="beers-manager-items">
      <Button
        variant="empty"
        className="beers-manager-items__switcher"
        title="switch pub"
        disabled={isSelectingBeers}
        onClick={() => setShowPubSwitcher((prevState) => !prevState)}
      >
        <PubSwitcherLogo />
      </Button>
    </div>
  );
};

export default NavbarItems;
